import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'

import Icon from './Icon'
import { BUTTONS_STYLE } from './styles'

const useStyles = createUseStyles({
  button: {
    ...BUTTONS_STYLE,
    color: '#F57561',
    textTransform: 'lowercase',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    marginLeft: 8,
  },
})

interface Props {
  title: string
  onClick: () => void
}

export const DeleteButton: FC<Props> = flowMax(
  addDisplayName('DeleteButton'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ title, onClick, classes }) => (
    <button onClick={onClick} className={classes.button}>
      <Icon name={'delete'} />
      <span className={classes.title}>{title}</span>
    </button>
  )
)
